import {
  GoalsIcon,
  ImplementationIcon,
  PurposeIcon,
  StartDateIcon,
} from 'secondstep-components'
import AddUserPlanModal from 'components/AddUserPlanModal'
import GoalsModal from 'components/GoalsModal'
import HostAllStaffModal from 'components/HostAllStaffModal'
import InformFamilyModal from 'components/InformFamilyModal'
import ImplementationApproachModal from 'components/ImplementationApproachModal'
import KickoffModal from 'components/KickoffModal'
import ProgramStartDateModal from 'components/ProgramStartDateModal'
import PurposeModal from 'components/PurposeModal'
import SummaryModal from 'components/SummaryModal'
import {
  ADD_USERS_TEXT,
  GOALS_TEXT,
  HOST_TEXT,
  IMPLEMENTATION_APPROACH_TEXT,
  INFORM_TEXT,
  PREPARE_TEXT,
  PROGRAM_START_DATE_TEXT,
  PURPOSE_TEXT,
  SUMMARY_TEXT,
} from './constants'

export const dropdownOptions = [
  { key: 'plan', name: 'Create Your Implementation Plan' },
  { key: 'launch', name: 'Launch the Program' },
  { key: 'monitor', name: 'Monitor and Support' },
]

export const goalNavigationData = [
  {
    key: 'goal 1',
    label: 'Goal 1',
    isOptional: false,
    isCompletedProp: 'goal1IsCompleted',
  },
  {
    key: 'goal 2',
    label: 'Goal 2',
    isOptional: false,
    isCompletedProp: 'goal2IsCompleted',
  },
  {
    key: 'goal 3',
    label: 'Goal 3',
    isOptional: true,
    isCompletedProp: 'goal3IsCompleted',
  },
  {
    key: 'goal 4',
    label: 'Goal 4',
    isOptional: true,
    isCompletedProp: 'goal4IsCompleted',
  },
  {
    key: 'goal 5',
    label: 'Goal 5',
    isOptional: true,
    isCompletedProp: 'goal5IsCompleted',
  },
]

export const modalMap = {
  [ADD_USERS_TEXT]: {
    component: AddUserPlanModal,
  },
  [PREPARE_TEXT]: {
    component: KickoffModal,
  },
  [HOST_TEXT]: {
    component: HostAllStaffModal,
  },
  [INFORM_TEXT]: {
    component: InformFamilyModal,
  },
  [GOALS_TEXT]: {
    component: GoalsModal,
  },
  [IMPLEMENTATION_APPROACH_TEXT]: {
    component: ImplementationApproachModal,
  },
  [PROGRAM_START_DATE_TEXT]: {
    component: ProgramStartDateModal,
  },
  [PURPOSE_TEXT]: {
    component: PurposeModal,
  },
  [SUMMARY_TEXT]: {
    component: SummaryModal,
  },
}

export const stepDataMap = {
  plan: {
    0: {
      estimatedTime: '2 min.',
      Icon: ImplementationIcon,
      label: IMPLEMENTATION_APPROACH_TEXT,
      modalName: IMPLEMENTATION_APPROACH_TEXT,
      number: 1,
      title: 'Choose Your Implementation Approach',
    },
    1: {
      estimatedTime: '5 min.',
      Icon: GoalsIcon,
      label: GOALS_TEXT,
      modalName: GOALS_TEXT,
      number: 2,
      title: 'Add Goals for Your School',
    },
    2: {
      estimatedTime: '5 min.',
      Icon: PurposeIcon,
      label: PURPOSE_TEXT,
      modalName: PURPOSE_TEXT,
      number: 3,
      title: 'Add Your Purpose Statement',
    },
    3: {
      estimatedTime: '1 min.',
      Icon: StartDateIcon,
      label: PROGRAM_START_DATE_TEXT,
      modalName: PROGRAM_START_DATE_TEXT,
      number: 4,
      title: 'Add Program Start Date',
    },
  },
  launch: {
    0: {
      estimatedTime: '1 min.',
      Icon: ImplementationIcon,
      label: ADD_USERS_TEXT,
      modalName: ADD_USERS_TEXT,
      number: 1,
      title: 'Plan to Add Users',
    },
    1: {
      estimatedTime: '15-30 min.',
      Icon: PurposeIcon,
      label: PREPARE_TEXT,
      modalName: PREPARE_TEXT,
      number: 2,
      title: 'Prepare for All-Staff Presentation',
    },
    2: {
      estimatedTime: '30-60 min.',
      Icon: GoalsIcon,
      label: HOST_TEXT,
      modalName: HOST_TEXT,
      number: 3,
      title: 'Host All-Staff Presentation',
    },
    3: {
      estimatedTime: '15 min.',
      Icon: StartDateIcon,
      label: INFORM_TEXT,
      modalName: INFORM_TEXT,
      number: 4,
      title: 'Inform Families About the Programs',
    },
  },
}
